// sphereReducer.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SphereState {
  sphereId: string | null;
}

const initialState: SphereState = {
  sphereId: null,
};

/** 
 * Payload for setSphereId includes both the sphereId 
 * and an optional source to log where dispatch came from.
 */
interface SetSphereIdPayload {
  sphereId: string;
  source?: string;
}

const sphereSlice = createSlice({
  name: 'sphere',
  initialState,
  reducers: {
    setSphereId(state, action: PayloadAction<SetSphereIdPayload>) {
      const { sphereId, source } = action.payload;
      console.log('*** sphereSlice: setSphereId', sphereId, 'source:', source);
      state.sphereId = sphereId;
    },
  },
});

export const { setSphereId } = sphereSlice.actions;

export default sphereSlice.reducer;
